import { ISector } from "../models/ITerritory";

export const SECTORS: ISector[] = [
  {
    name: { fr: "Secteur 1", en: "Area 1" },
    code: "1",
    territory: "Centre-ville",
    description: [],
  },
  {
    name: { fr: "Secteur 2", en: "Area 2" },
    code: "2",
    territory: "Quartiers centraux",
    description: [],
  },
  {
    name: { fr: "Secteur 3", en: "Area 3" },
    code: "3",
    territory: "Quartiers centraux",
    description: [],
  },
  {
    name: { fr: "Secteur 4", en: "Area 4" },
    code: "4",
    territory: "Périphérie",
    description: [],
  },
  {
    name: { fr: "Secteur 5A", en: "Area 5A" },
    code: "5",
    territory: "Périphérie",
    description: [],
  },
  {
    name: { fr: "Secteur 5B", en: "Area 5B" },
    code: "6",
    territory: "Extrémités",
    description: [],
  },
];
